import { Injectable } from '@angular/core';
import { Environment } from '@core/services/common';
import { LogService } from '@core/services/core/log.service';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { fromEvent, Observable, of } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface DispatchPostMessageOptions<T = any> {
  target: Window;
  targetOrigin: string;
  transfer?: Transferable[];
  message: T;
}

@Injectable({
  providedIn: 'root'
})
export class EventsHelperService {

  private static readonly POST_MESSAGE_DEFAULT_EVENT = 'message';

  constructor(private log: LogService, private mmobileHelper: MMobileHelperService) { }

  getUpdates(id: string, target: EventTarget = window) {
    if (!target) {
      return of(null as Event);
    }
    return fromEvent(target, id);
  }

  getPostMessages(target: Window = window) {
    return this.getUpdates(EventsHelperService.POST_MESSAGE_DEFAULT_EVENT, target) as Observable<MessageEvent>;
  }

  getAllowedOriginPostMessages(allowedOrigins: string[] = [], target: Window = window) {
    return this.getPostMessages(target).pipe(filter(message =>
      this.messageComingFromAllowedOrigin(message, allowedOrigins)));
  }

  dispatchPostMessageEvent(configuration: DispatchPostMessageOptions) {
    const { target = window, targetOrigin = window.location.origin, transfer = [], message } =
    configuration || {};

    if (!message) {
      this.log.w(this, 'A message should be provided before dispatching a postMessage');
      return;
    }

    target.postMessage(message, targetOrigin, transfer);
  }

  getHealthAppOrigin() {
    const healthAppLocalOrigin = Environment.config().healthAppLocalOrigin || '';
    if (!healthAppLocalOrigin) {
      return this.mmobileHelper.getCustomConfigData('URLS', 'HEALTH_APP') || '';
    } else {
      return healthAppLocalOrigin;
    }
  }

  getHealthAppContext() {
    return this.mmobileHelper.getCustomConfigData('URLS', 'HEALTH_APP_CONTEXT') || '';
  }

  private messageComingFromAllowedOrigin(message: MessageEvent, allowedOrigins: string[] = []) {
    return allowedOrigins.some(origin => origin === message?.origin);
  }



}
